import React, { useState, useEffect } from "react";
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import logo from './loho.png';

const LINKS = [
    { label: "STRONA GŁÓWNA", href: "/" },
    { label: "REPERTUAR",     href: "#repertuar" },
    { label: "AKTUALNOŚCI",   href: "#aktualnosci" },
    { label: "SPEKTAKLE",     href: "#spetakle" },
    { label: "WARSZTATY",     href: "#warsztaty" },
];

const Navbar = () => {
    const [nav, setNav] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 30);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        document.body.style.overflow = nav ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [nav]);

    return (
        <>
            <nav className={`w-full fixed top-0 left-0 z-50 transition-all duration-500 ${
                scrolled
                    ? 'bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/8 shadow-xl shadow-black/60'
                    : 'bg-gradient-to-b from-black/60 to-transparent'
            }`}>
                <div className="flex justify-between items-center h-24 max-w-[1280px] mx-auto px-6">

                    {/* Logo + nazwa */}
                    <a href="/" className="flex items-center gap-4 group flex-shrink-0">
                        <img
                            src={logo}
                            className="h-14 w-14 transition-transform duration-300 group-hover:scale-105"
                            alt="Logo Teatr Łątek"
                        />
                        <div className="hidden sm:block leading-tight">
                            <p className="text-white text-sm font-bold tracking-[0.25em] uppercase">
                                Teatr Łątek
                            </p>
                            <p className="text-red-400 text-[10px] tracking-[0.2em] uppercase mt-0.5">
                                Supraśl
                            </p>
                        </div>
                    </a>

                    {/* Desktop links */}
                    <ul className="hidden md:flex items-center gap-8">
                        {LINKS.map(({ label, href }) => (
                            <li key={label}>
                                <a
                                    href={href}
                                    className="relative text-[11px] tracking-[0.18em] text-gray-400 hover:text-white transition-colors duration-200 pb-1 group"
                                >
                                    {label}
                                    <span className="absolute bottom-0 left-0 h-px w-0 bg-red-500 group-hover:w-full transition-all duration-300 ease-out" />
                                </a>
                            </li>
                        ))}
                    </ul>

                    {/* Hamburger */}
                    <button
                        onClick={() => setNav(true)}
                        className="md:hidden p-2 text-gray-400 hover:text-white transition-colors"
                        aria-label="Otwórz menu"
                    >
                        <AiOutlineMenu size={22} />
                    </button>
                </div>
            </nav>

            {/* Backdrop mobilny */}
            <div
                className={`fixed inset-0 bg-black/70 backdrop-blur-sm z-40 md:hidden transition-opacity duration-300 ${
                    nav ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                }`}
                onClick={() => setNav(false)}
            />

            {/* Szuflada mobilna (wysuwa się z prawej) */}
            <div className={`fixed top-0 right-0 h-full w-72 bg-[#0d0d0d] border-l border-white/10 z-50 md:hidden transition-transform duration-300 ease-in-out ${
                nav ? 'translate-x-0' : 'translate-x-full'
            }`}>
                <div className="flex items-center justify-between px-6 py-5 border-b border-white/10">
                    <div className="flex items-center gap-3">
                        <img src={logo} className="h-10 w-10" alt="Logo" />
                        <div>
                            <p className="text-white text-xs font-bold tracking-[0.2em] uppercase">Teatr Łątek</p>
                            <p className="text-red-400 text-[10px] tracking-widest uppercase mt-0.5">Supraśl</p>
                        </div>
                    </div>
                    <button
                        onClick={() => setNav(false)}
                        className="text-gray-500 hover:text-white transition-colors p-1"
                        aria-label="Zamknij menu"
                    >
                        <AiOutlineClose size={20} />
                    </button>
                </div>

                <ul className="py-2">
                    {LINKS.map(({ label, href }) => (
                        <li key={label} className="border-b border-white/5">
                            <a
                                href={href}
                                className="flex items-center gap-4 px-6 py-4 text-[11px] tracking-[0.18em] text-gray-400 hover:text-white hover:bg-white/5 transition-all duration-200"
                                onClick={() => setNav(false)}
                            >
                                <span className="w-1 h-1 rounded-full bg-red-500 flex-shrink-0" />
                                {label}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default Navbar;
